import styled from "styled-components";

export const PrivacyNoticeContainer = styled.div(props => ({
textAlign:"justify",  
fontSize:"1rem"
}));

export const HeadingStyled = styled.p`
  color: #af1c07;
  font-size: 1.7rem;
  margin-top: 20px;
  font-weight: 800;
`;

export const LinkStyled = styled.a`
  color: #af1c07;
`;